import React from "react";
import {
  IconButton,
  MenuItem,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { RemoveCircleOutline } from "@mui/icons-material";
import AsyncSelect from "react-select/async";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { FREQUENCY_OPTIONS } from "./formHelpers";

const SessionRow = React.memo(
  ({
    session,
    index,
    onUpdate,
    onRemove,
    isRemovable,
    loadOptions,
    allSessionOptions,
    translations,
    daysOfWeek,
  }) => {
    return (
      <MDBox>
        <MDBox
          display="flex"
          gap={2}
          alignItems="flex-end"
          flexDirection={{ xs: "column", md: "row" }}
        >
          <MDBox flex={2} sx={{ width: "100%" }}>
            <AsyncSelect
              cacheOptions
              defaultOptions={allSessionOptions}
              placeholder="Select Session"
              loadOptions={loadOptions}
              onChange={(opt) => onUpdate(index, "sessionValue", opt)}
              value={session.sessionValue}
              menuPortalTarget={document.body}
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: 40,
                  borderRadius: 8,
                  borderColor: "#e0e0e0",
                  boxShadow: "none",
                  "&:hover": { borderColor: "#3560AD" },
                  ...(translations?.setlang === "ar"
                    ? { direction: "rtl" }
                    : {}),
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </MDBox>

          <MDBox flex={1} sx={{ width: "100%" }}>
            <MDInput
              fullWidth
              label="Total Number of Sessions"
              type="number"
              value={session.quantity}
              onChange={(e) => onUpdate(index, "quantity", e.target.value)}
              sx={{ "& .MuiInputBase-root": { height: 40 } }}
            />
          </MDBox>

          <MDBox flex={1} sx={{ width: "100%" }}>
            <MDInput
              fullWidth
              select
              label="Frequency"
              value={session.frequency}
              onChange={(e) => {
                onUpdate(index, "frequency", e.target.value);
                // Reset selected days when changing frequency
                if (e.target.value === "Daily") {
                  onUpdate(index, "selectedDays", []);
                }
              }}
              sx={{ "& .MuiInputBase-root": { height: 40 } }}
            >
              {FREQUENCY_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>

          <IconButton
            color="error"
            onClick={() => onRemove(index)}
            disabled={!isRemovable}
            sx={{ mb: 0.5 }}
          >
            <RemoveCircleOutline />
          </IconButton>
        </MDBox>

        {/* Day Selection for Custom */}
        {session.frequency === "Custom" && daysOfWeek && (
          <MDBox
            p={2}
            sx={{ border: "1px dashed #ced4da", borderRadius: "8px", mb: 2 }}
          >
            <MDTypography variant="caption" sx={{ display: "block", mb: 1 }}>
              Select Days
            </MDTypography>
            <FormGroup row>
              {daysOfWeek.map((day) => (
                <FormControlLabel
                  key={day.value}
                  label={
                    <MDTypography variant="button">{day.label}</MDTypography>
                  }
                  control={
                    <Checkbox
                      checked={
                        session.selectedDays?.includes(day.value) || false
                      }
                      onChange={() => {
                        const newDays = session.selectedDays?.includes(
                          day.value,
                        )
                          ? session.selectedDays.filter((d) => d !== day.value)
                          : [...(session.selectedDays || []), day.value];
                        onUpdate(index, "selectedDays", newDays);
                      }}
                    />
                  }
                />
              ))}
            </FormGroup>
          </MDBox>
        )}
      </MDBox>
    );
  },
);

export default SessionRow;
